import { ensureHttps } from "@/lib/https";

export function money(n, symbol = "₹") {
  const v = Number(n || 0);
  return `${symbol}${v.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = (Date.now() - d.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
  return d.toLocaleDateString("en-IN", { day: "numeric", month: "short" });
}

export function fmtTime(iso) {
  if (!iso) return "";
  return new Date(iso).toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit" });
}

export function asset(url) {
  if (!url) return url;
  if (url.startsWith("/")) {
    const raw = process.env.REACT_APP_BACKEND_URL || "";
    const base = (process.env.NODE_ENV === "production" && /localhost|127\.0\.0\.1/.test(raw)) ? "" : raw;
    return ensureHttps(`${base}${url}`) || `${base}${url}`;
  }
  return ensureHttps(url);
}
